import { AccessCountries } from 'domains/user/UserCountriesPermissions'

import { protectedApi } from './requester'

export const getCountriesPermissions = () => {
  return protectedApi.get<AccessCountries>(`/access-countries`).then((response) => response.data)
}

export const getUserCountriesPermissions = (username: string) => {
  return protectedApi
    .get<string[]>(`/user/${username}/access-countries`)
    .then((response) => response.data)
}

export const updateUserCountriesPermissions = (username: string, userAccessCountries: string[]) => {
  return protectedApi
    .put<void>(`/user/${username}/access-countries`, userAccessCountries)
    .then((response) => response.data)
}
